import { Injectable, Type } from '@angular/core';
import { InformationTemplateComponent } from './information-template/information-template.component';

import { BaseService } from "../base.service";
import { BaseResultTemplateComponent } from "../base-result-template.component";
import { ResultTemplateComponent } from "./result-template/result-template.component";
import { GenerischeFreigabeVariables } from './generische-freigabe.variables';

@Injectable({providedIn: 'root'})
export class GenerischeFreigabeService extends BaseService {

  WORKFLOW_NAME = 'generische-freigabe';
  static WORKFLOW_NAME = 'generische-freigabe';

  getInformationTemplate(): Type<InformationTemplateComponent> {
    return InformationTemplateComponent;
  }

  getResultTemplate(): Type<BaseResultTemplateComponent> {
    return ResultTemplateComponent;
  }

  getRelatedContentOrdering(): string[] {
    return ['annotatedDocument', 'documentToApprove', 'originalDocument', 'attachments'];
  }

  getRelatedContentTranslation(): Record<string, string> {
    return {
      [GenerischeFreigabeVariables.annotatedDocument]: this.WORKFLOW_NAME + '.RELATED_CONTENT.annotatedDocument',
      [GenerischeFreigabeVariables.attachments]: this.WORKFLOW_NAME + '.RELATED_CONTENT.attachments',
      [GenerischeFreigabeVariables.originalDocument]: this.WORKFLOW_NAME + '.RELATED_CONTENT.originalDocument',
      [GenerischeFreigabeVariables.documentToApprove]: this.WORKFLOW_NAME + '.RELATED_CONTENT.documentToApprove'
    };
  }

  getRelatedContentDisplayMode():  Record<string, 'single' | 'all'>  {
    return {
      [GenerischeFreigabeVariables.annotatedDocument]: 'single',
      [GenerischeFreigabeVariables.attachments]: 'all',
      [GenerischeFreigabeVariables.originalDocument]: 'single',
      [GenerischeFreigabeVariables.documentToApprove]: 'single'
    };
  }


}
